export { getStaticPropsCreditCardsPage } from './getStaticPropsCreditCardsPage'
export { dataLayerEvents } from './dataLayerEvents'
